import React, { useState } from "react";
import { CalendarIcon } from "../../../assets/Icons/Calendar";
import { ClockIcon } from "../../../assets/Icons/ClockIcon";
import "./CustomFieldsTooltip.scss";

// Displays hover tooltip with aging and due date information
export function CustomFieldsTooltip({
  trigger,
  agingDays,
  dueDate,
  agingLabel = "Ageing in (By Status)",
}) {
  const [isVisible, setIsVisible] = useState(false);

  return (
    <div
      className="custom-fields-tooltip-wrapper"
      onMouseEnter={() => setIsVisible(true)}
      onMouseLeave={() => setIsVisible(false)}
    >
      <div className="custom-fields-tooltip-trigger">{trigger}</div>
      {isVisible && (
        <div className="custom-fields-tooltip-popup">
          <div className="custom-fields-tooltip-arrow"></div>
          <div className="custom-fields-tooltip-content">
            <div className="custom-fields-tooltip-label">{agingLabel}</div>
          </div>
        </div>
      )}
    </div>
  );
}
